module.exports = __webpack_public_path__ + "img/header_common.8691fa52.png";